import React, { useState } from 'react';
import { Container, Row, Col, Button, Modal, Badge } from 'react-bootstrap';

const WorkGallery = ({ show, onHide }) => {
  const [filter, setFilter] = useState('all');
  const [selectedItem, setSelectedItem] = useState(null);

  const galleryItems = [
    { id: 1, type: 'image', src: '/images/painting.png', title: 'Exterior Painting', category: 'painting' },
    { id: 2, type: 'image', src: '/images/water_proofing.png', title: 'Roof Waterproofing', category: 'waterproofing' },
    { id: 3, type: 'video', src: '/images/vedio 1.mp4', title: 'Waterproofing Process', category: 'waterproofing' },
    { id: 4, type: 'image', src: '/images/painting_ex.png', title: 'Commercial Painting', category: 'painting' },
    { id: 5, type: 'image', src: '/images/water_proofing_1.png', title: 'Basement Waterproofing', category: 'waterproofing' },
    { id: 6, type: 'video', src: '/images/vedio 2.mp4', title: 'Painting Transformation', category: 'waterproofing' },
    { id: 7, type: 'image', src: '/images/painting_in.png', title: 'Interior Painting', category: 'painting' },
    { id: 8, type: 'image', src: '/images/water_proofing_2.png', title: 'Terrace Waterproofing', category: 'waterproofing' },
    { id: 9, type: 'image', src: '/images/painting_2.png', title: 'Residential Painting', category: 'painting' },
    { id: 10, type: 'image', src: '/images/water_proofing_3.png', title: 'Wall Waterproofing', category: 'waterproofing' },
    { id: 12, type: 'image', src: '/images/water_proofing_4.png', title: 'Leakage Repair', category: 'waterproofing' },
    { id: 13, type: 'image', src: '/images/paint_wall.png', title: 'Compound Wall Painting ', category: 'painting' },
    { id: 14, type: 'image', src: '/images/wall_texture.png', title: 'Custom Wall Art', category: 'painting' },
    { id: 15, type: 'image', src: '/images/image 1.jpeg', title: 'Modern Home Finish', category: 'painting' },
  ];

  const filteredItems = filter === 'all' 
    ? galleryItems 
    : galleryItems.filter(item => item.type === filter || item.category === filter);

  return (
    <>
      <Modal show={show} onHide={onHide} size="xl" centered scrollable className="work-gallery-modal">
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fw-bold display-6">
            Our <span className="text-primary">Complete</span> Portfolio
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-4">
          <Container>
            <div className="d-flex flex-wrap justify-content-center gap-2 mb-5">
              <Button 
                variant={filter === 'all' ? 'primary' : 'outline-primary'} 
                onClick={() => setFilter('all')}
                className="px-4 rounded-pill"
              >
                All Projects
              </Button>
              <Button 
                variant={filter === 'painting' ? 'primary' : 'outline-primary'} 
                onClick={() => setFilter('painting')}
                className="px-4 rounded-pill"
              >
                Painting
              </Button>
              <Button 
                variant={filter === 'waterproofing' ? 'primary' : 'outline-primary'} 
                onClick={() => setFilter('waterproofing')}
                className="px-4 rounded-pill"
              >
                Waterproofing
              </Button>
              <Button 
                variant={filter === 'video' ? 'primary' : 'outline-primary'} 
                onClick={() => setFilter('video')}
                className="px-4 rounded-pill"
              >
                Videos
              </Button>
            </div>

            <Row className="g-4">
              {filteredItems.map((item) => (
                <Col key={item.id} md={6} lg={4}>
                  <div 
                    className="gallery-card rounded-4 overflow-hidden shadow-sm h-100 position-relative cursor-pointer"
                    onClick={() => setSelectedItem(item)}
                  >
                    {item.type === 'image' ? (
                      <div className="gallery-media-wrapper">
                        <img 
                          src={item.src} 
                          alt={item.title} 
                          className="img-fluid w-100 h-100 object-fit-cover"
                          style={{ minHeight: '250px', maxHeight: '250px' }}
                        />
                      </div>
                    ) : (
                      <div className="gallery-media-wrapper position-relative">
                        <video 
                          className="w-100 h-100 object-fit-cover"
                          style={{ minHeight: '250px', maxHeight: '250px' }}
                          muted
                          loop
                          onMouseOver={e => e.target.play()}
                          onMouseOut={e => { e.target.pause(); e.target.currentTime = 0; }}
                        >
                          <source src={item.src} type="video/mp4" />
                        </video>
                        <div className="video-overlay position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center pointer-events-none">
                          <div className="play-icon-circle bg-white bg-opacity-25 rounded-circle p-3">
                            <i className="fas fa-play text-white fa-2x"></i>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="gallery-card-content p-3 bg-white">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <Badge bg={item.category === 'painting' ? 'warning' : 'primary'} className="text-uppercase px-2 py-1">
                          {item.category}
                        </Badge>
                        <small className="text-muted">
                          <i className={`fas ${item.type === 'video' ? 'fa-video' : 'fa-image'} me-1`}></i>
                          {item.type.charAt(0).toUpperCase() + item.type.slice(1)}
                        </small>
                      </div>
                      <h5 className="fw-bold mb-0">{item.title}</h5>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0">
          <Button variant="secondary" onClick={onHide} className="px-4">
            Close Gallery
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Lightbox Modal */}
      <Modal 
        show={!!selectedItem} 
        onHide={() => setSelectedItem(null)} 
        size="lg" 
        centered 
        contentClassName="bg-transparent border-0"
        className="gallery-lightbox"
      >
        <Modal.Header closeButton closeVariant="white" className="border-0 position-absolute top-0 end-0 z-index-10"></Modal.Header>
        <Modal.Body className="p-0">
          {selectedItem && (
            <div className="lightbox-content text-center">
              {selectedItem.type === 'image' ? (
                <img src={selectedItem.src} alt={selectedItem.title} className="img-fluid rounded-4 shadow-lg" />
              ) : (
                <video controls autoPlay className="w-100 rounded-4 shadow-lg">
                  <source src={selectedItem.src} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              )}
              <div className="mt-3 text-white">
                <h4 className="fw-bold">{selectedItem.title}</h4>
                <Badge bg={selectedItem.category === 'painting' ? 'warning' : 'primary'} className="text-uppercase">
                  {selectedItem.category}
                </Badge>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default WorkGallery;
